const userRoles = {
    CLIENT_ADMIN: "Admin",
    CLIENT_USER: "Kasutaja",
    PARTNER: "Partner",
    EPP: "EPP",
}

export default userRoles;